import React, { useEffect, useState } from "react";
import Evolution from "../assets/images/games-icon/Ezugi.webp";
import Aviator from "../assets/images/games-icon/Aviatornew.webp";
import CasinoIcon from "../assets/images/icons/roulette.png";
import AviatorIcon from "../assets/images/icons/flight.png";
import ExchangeIcon from "../assets/images/icons/exchange-icon.png";
import HomeIcon from "../assets/images/icons/home.png";
import SportsIcon from "../assets/images/icons/football.png";
import DepositIcon from "../assets/images/icons/wallet.png";
import { CasinoProviders } from "../lib/data";

export default function BottomNav() {
  const [activePage, setActivePage] = useState("");
  return (
    <div>
      <footer className="footer d-md-none">
        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100 ">
          <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
            {/* <li>
              <a
                className={activePage === "casino/ezugi" ? "active" : ""}
                href={CasinoProviders["ezugi"]?.href}
              >
                <img src={CasinoIcon} />
                <span>Ezugi</span>
              </a>
            </li> */}
            <li>
              <a href={"/casino/spribe/aviator"}>
                <img src={AviatorIcon} />
                <span>Aviator</span>
              </a>
            </li>
            {/* <li>
              <a
                className={activePage === "casino/evolution" ? "active" : ""}
                href={CasinoProviders["evolution"]?.href}
              >
                <img src={Evolution} />
                <span>Evolution</span>
              </a>
            </li> */}
            <li>
              <a href="/exchange/Cricket">
                <img src={SportsIcon} />
                <span>Sports</span>
              </a>
            </li>
            <li className="home">
              <a className="active" href="/home">
                <img src={HomeIcon} />
                <span>Home</span>
              </a>
            </li>

            <li>
              <a href="/live-games">
                <img src={CasinoIcon} />
                <span>Casino</span>
              </a>
            </li>
            <li>
              <a href="/deposit">
                <img src={DepositIcon} className="wallet-img" />
                <span>Deposit</span>
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </div>
  );
}
